require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./quaterlynewsletterjuly-2022.json") })
        }
      }, "path---quaterlynewsletterjuly-2022");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---quaterlynewsletterjuly-2022!./.cache/json/quaterlynewsletterjuly-2022.json
// module id = 1179
// module chunks = 231608221292675